export default {
  STOCK: '證券',
  FUTURES: '期貨',
  FOREX: '外匯',
  IB: 'EddidPro',
  FUND: '基金',
  mt5: '(MT5)',
  mf: '(Eddid FX Pro)',
  ACCOUNT: '賬戶 | ',
  MF: 'FX Pro',
  PM: '現貨黃金',
  fundCash: '基金',
  stockOptionsCash: '香港股票期權賬戶(現金)',
  securitiesCash: '香港及環球證券賬戶(現金)',
  securitiesMargin: '香港及環球證券賬戶(保證金)',
  securitiesDayTradeMargin: '香港證券即日買賣賬戶(保證金)',
  futuresMargin: '香港及環球期貨賬戶(保證金)',
  futuresDayTradeMargin: '香港期貨即日買賣賬戶(保證金)',
  interactiveBrokerIntegratedMargin: '盈透證券綜合戶口(保證金)',
  please_select: '請選擇',
  please_select_currency: '請選擇幣種',
  submit: '提交',
  please_input: '請輸入',
  contiune: '繼續',
  ok: '確定',
  edit: '編輯',
  cancel: '取消',
  yes: '是',
  no: '否',
  resign: '重簽',
  cancelLogout: '已取消退出登錄',
  noCancel: '該訂單不能撤銷',
  codeFail: '驗證碼不正確',
  changeSuccess: '修改成功！ ',
  changeFail: '修改失敗',
  inputNewPassword: '請輸入新密碼',
  inputNewPasswordAgain: '請再次輸入新密碼',
  notIdentical: '兩次密碼不一致',
  uploadFail: '網絡錯誤,上傳失敗！ ',
  imageRepeat: '不能重複上傳！ ',
  fail: '失敗',
  loadingFailTip: '加載失敗',
  exhangeTo: '兌換至',
  usd: '美元',
  hkd: '港幣',
  cny: '人民幣',
  cencel_dialog: {
    tip: {
      withdrawal: '確認要撤銷本次取款嗎？ ',
      transfer: '確認要撤銷本次轉賬嗎？ '
    },
    cancel: {
      withdrawal: '閣下已成功撤回本次取款。 ',
      transfer: '閣下已成功撤回本次內部轉賬。 '
    },
    check_info: '確認信息',
    reminder: '請確認信息並提交信息'
  },
  preview_dialog: {
    tip: {
      deposit: '請核對您的存款憑證切勿重複上傳，如有疑問請與我們聯繫',
      withdrawal: '提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫',
      transfer: '轉賬申請期間如您在交易，可能導致轉賬失敗，如有問題請與我們聯繫',
      attention: '注意事項：'
    },
    tip1: '<div style="margin-bottom: 4px">1.本公司收取銀行轉賬手續費每筆350港幣</div>' +
      '<div style="margin-bottom: 4px">2.銀行可能收取行政費用，具體​​請向收款銀行查詢</div>' +
      '3.如匯款往內地，可能會有內地銀行拒收退回情況。若發生退款，已收取手續費不做退回',
    withdrawalTip: '<div style="margin-bottom: 4px">1.由於閣下兌換並賣出所贈送的股票未符合是次活動要求的交易任務，根據活動規則，艾德證券期貨將在閣下是次提款時收取27美元的首年賬戶管理費</div>' +
      '2.取款申請期間如您進行交易，可能導致轉賬失敗，如有問題請與我們聯系',
    withdrawalfinanceTip: '<div style="margin-bottom: 4px">1.閣下已提交「一手融」 新股認購申請，且提款後證券賬戶總資產低於 HKD5,000.00，根據公司政策，閣下是次提款需繳付總額外手續費{}或等值貨幣。(以每只「一手融」認購申請繳付HKD500.00額外手續費計算)</div>' +
      '2.提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫',
    withdrawalallTip: `<div style="margin-bottom: 4px">1.由於閣下兌換並賣出所贈送的股票未符合是次活動要求的交易任務，根據活動規則，艾德證券期貨將在閣下是次提款時收取27美元的首年賬戶管理費</div>
                      <div style="margin-bottom: 4px">2.閣下已提交「一手融」 新股認購申請，且提款後證券賬戶總資產低於 HKD5,000.00，根據公司政策，閣下是次提款需繳付總額外手續費{}或等值貨幣。(以每只「一手融」認購申請繳付HKD500.00額外手續費計算)</div>
                      <div style="margin-bottom: 4px">3.提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫</div>`,
    overseaTip: '<div style="margin-bottom: 4px">1.由於閣下兌換並賣出所贈送的股票未符合是次活動要求的交易任務，根據活動規則，艾德證券期貨將在閣下是次提款時收取27美元的首年賬戶管理費</div>' +
      '<div style="margin-bottom: 4px">2.提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫</div>' +
      '<div style="margin-bottom: 4px">3.本公司收取銀行轉賬手續費每筆350港幣</div>' +
      '<div style="margin-bottom: 4px">4.銀行可能收取行政費用，具體請向收款銀行查詢</div>' +
      '5.如匯款往內地，可能會有內地銀行拒收退回情況。若發生退款，已收取手續費不做退回',
    overseafinanceTip: '<div style="margin-bottom: 4px">1.閣下已提交「一手融」 新股認購申請，且提款後證券賬戶總資產低於 HKD5,000.00，根據公司政策，閣下是次提款需繳付總額外手續費{}或等值貨幣。(以每只「一手融」認購申請繳付HKD500.00額外手續費計算)</div>' +
      '<div style="margin-bottom: 4px">2.提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫</div>' +
      '<div style="margin-bottom: 4px">3.本公司收取銀行轉賬手續費每筆350港幣</div>' +
      '<div style="margin-bottom: 4px">4.銀行可能收取行政費用，具體請向收款銀行查詢</div>' +
      '5.如匯款往內地，可能會有內地銀行拒收退回情況。若發生退款，已收取手續費不做退回',
    overseaallTip: '<div style="margin-bottom: 4px">1.由於閣下兌換並賣出所贈送的股票未符合是次活動要求的交易任務，根據活動規則，艾德證券期貨將在閣下是次提款時收取27美元的首年賬戶管理費</div>' +
      '<div style="margin-bottom: 4px">2.閣下已提交「一手融」 新股認購申請，且提款後證券賬戶總資產低於 HKD5,000.00，根據公司政策，閣下是次提款需繳付總額外手續費{}或等值貨幣。(以每只「一手融」認購申請繳付HKD500.00額外手續費計算)</div>' +
      '<div style="margin-bottom: 4px">3.提款申請期間如您在交易，可能導致提款失敗，如有問題請與我們聯繫</div>' +
      '<div style="margin-bottom: 4px">4.本公司收取銀行轉賬手續費每筆350港幣</div>' +
      '<div style="margin-bottom: 4px">5.銀行可能收取行政費用，具體請向收款銀行查詢</div>' +
      '6.如匯款往內地，可能會有內地銀行拒收退回情況。若發生退款，已收取手續費不做退回',
    transferfinanceTip: '<div style="margin-bottom: 4px">1.閣下已提交「一手融」 新股認購申請，且轉賬後證券賬戶總資產低於 HKD5,000.00，根據公司政策，閣下是次轉賬需繳付總額外手續費{}或等值貨幣。(以每只「一手融」認購申請繳付HKD500.00額外手續費計算)</div>' +
      '2.轉賬申請期間如您在交易，可能導致轉賬失敗，如有問題請與我們聯繫',
    transferTip: '<div style="margin-bottom: 4px">轉賬申請期間如您在交易，可能導致轉賬失敗，如有問題請與我們聯繫</div>',
    check_info: '核對信息',
    reminder: '請確認信息並提交信息',
    // 轉賬
    outAccount: '扣款賬號',
    inAccount: '收款賬號',
    outAmount: '轉賬金額',
    // 出金
    account_number: '賬號',
    bank_card_number: '銀行卡號',
    bank_card_name: '銀行名稱',
    withdrawal_amount: '取款金額',
    serviceCharge: '服務費',
    accountFee: '賬戶管理費',
    actualAmount: '實際取款金額',
    withdrawal_name: '英文名/中文拼音',
    withdrawal_bank_name: '銀行名稱',
    withdrawal_bank_card: '銀行卡號',
    withdrawal_swift_no: 'SWIFT Code（銀行國際代碼)',
    otherBankName: '其他銀行名稱',
    otherBankCard: '其他銀行賬號',
    financeFee: '一手融手續費',
    actualtransferAmount: '實際轉賬金額',
    // 入金
    account_info: '賬號',
    bank_info: '銀行卡號',
    eddid_bank: '艾德銀行卡號',
    depositAmount: '存款金額',
    number: '客戶賬號',
    customer: '客戶姓名',
    amount: '預存款金額',
    // 換匯
    tradeAccount: '交易賬號',
    exchangeCurrency: '換匯貨幣',
    exchangeRate: '匯率',
    swapAmount: '換匯金額'
  },
  accountOpen: '子賬戶開戶申請',
  accountClose: '子賬戶註銷申請',
  three_list: {
    bankName: '銀行名稱',
    currency: '銀行貨幣',
    createdTime: '提交時間',
    bankNum: '銀行賬號',
    transfer: '轉賬',
    withdrawal: '取款',
    deposit: '存款',
    cenceledBtn: '撤銷',
    fromAccount: '扣款賬號',
    toAccount: '收款賬號',
    outAmount: '轉賬金額',
    accountNo: '賬號',
    bankCard: '銀行卡號',
    withdrawalAmout: '取款金額',
    depositAmout: '存款數額',
    remark: '備註',
    amout: '數額',
    fullName: '客戶姓名',
    applicationAmount: '申請金額',
    completed: '完成',
    processing: '已提交',
    failure: '失敗',
    submitted: '已提交',
    withdrawalcompleted: '已處理',
    checking: '已提交',
    verified: '已提交',
    latest_records: '最新記錄',
    view_more: '查看更多 >',
    order_No: '訂單編號：',
    enName: '英文名/中文拼音',
    swiftNo: 'SWIFT代碼',
    updatedTime: '更新時間',
    exchangeRate: '匯率',
    toCurrency: '兌換幣種',
    swapAmount: '換匯金額',
    applyService: '申請服務',
    fee: '費用明細',
    businessId: '備註',
    realAmount: '到賬金額',
    exchangeAmount: '換匯後入賬金額',
    fundBankType: '辦理業務',
    tradeAccountType: '交易賬戶',
    depositWay: '入金方式',
    withdrawoutWay: '出金方式',
    accountName: '賬戶名稱',
    applyTime: '申請時間',
    realExchangeRate: '實際匯率',
    exchangeAmountapply: '申請換匯金額',
    lockWay: '鎖定方向',
    exchangeRealAmount: '實際換匯金額'
  },
  upload: {
    uploadFail: '網絡異常，上傳圖片失敗',
    limitNumber: `只能上傳{0}張圖片`,
    limitSize: '圖片大小超出{0}M，上傳失敗'
  },
  eddidTips: '如您的資料與開戶時所提交的資料不相同，請致電 +852 2655 0338 / 400 120 0068（中國內地免費熱線） 或發送郵件至  cs@eddidsec.com 與客服人員聯繫, 謝謝。 ',
  applyText: '申請',
  nodata: '暫無數據',
  uploadImg: '請上傳圖片',
  yztransfer: '銀證轉賬',
  BANK_SECURITIES_ADD: '綁定銀證轉賬',
  BANK_SECURITIES_UNBIND: '解綁銀證轉賬',
  yzAccount: '銀證轉賬賬戶',
  commonAccount: '普通賬戶',
  iknow: '我知道了',
  knowIt: '知道了',
  gotIt: '知道了',
  statementArr: [
    {
      text: '《個人資料收集聲明》',
      link: 'https://download.eddidapp.com/pdf/TC/personalStatement.pdf'
    },
    {
      text: '《共同匯報標準聲明》',
      link: 'https://download.eddidapp.com/pdf/TC/statementCommonReportingStandards.pdf'
    },
    {
      text: '《客戶聲明》',
      link: 'https://download.eddidapp.com/pdf/TC/customerStatement.pdf'
    },
    {
      text: '《私隱政策聲明》',
      link: 'https://download.eddidapp.com/pdf/TC/privacy-policy-statement.pdf'
    },
    {
      text: '《風險披露聲明》',
      link: 'https://download.eddidapp.com/pdf/TC/Risk-Disclosure-Statement.pdf'
    },
    {
      text: '《業務條款及細則》',
      link: 'https://download.eddidapp.com/pdf/TC/Business-Terms-and-Conditions.pdf'
    },
    {
      text: '《客戶申請數字證書相關條款》',
      link: 'https://download.eddidapp.com/pdf/TC/customersTerms.pdf'
    }
  ],
  otherText: '其他',
  spInfo: '暫不支持Sharp Point交易賬戶進行此操作',
  riskTolerance: '風險承受能力',
  high: '高',
  medium: '中',
  low: '低',
  'invest': '投資目的',
  'speculation': '投機',
  'hedge': '對沖',
  'assetAppreciation': '資產增值',
  'interestIncome': '利息/股息收入',
  'targetError': '請選擇投資目的',
  'futuredErrorInfo': '開立期貨賬戶時投資目的不能僅為利息/股息收入',
  'riskError': '風險承受能力為中/低，不適合買賣結構性產品及衍生產品。',
  dormant: '不活躍',
  dormantTip: '閣下可透過流動應用程式申請重啟賬戶。如對上述事宜有任何查詢，歡迎致電+852 2655 0338 / 400 120 0068（中國內地免費熱線） 或 電郵至cs@eddidsec.com 與客戶服務部聯絡。',
  dormantDetailTip: '閣下之交易賬戶目前正處於不活躍狀態，現時之資金與證券提取功能將受到限制。閣下可透過流動應用程式申請重啟賬戶。如對上述事宜有任何查詢，歡迎致電+852 2655 0338 / 400 120 0068（中國內地免費熱線）或電郵至cs@eddidsec.com與客戶服務部聯絡。',
  reactivate: '重啟',
  'back': '返回',
  'sureBtn': '確認',
  blockedTip: '為配合最新監管要求，本公司已暫停閣下所在地區之存款服務。如有查詢，請致電 +852 2655 0338 / 400 120 0068（中國內地免費熱線）聯絡我們。'
}
